import React, { memo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme } from '@alycecom/ui';
import classNames from 'classnames';

import SupportLink from '../../../../../components/Shared/SupportLink';

const useStyles = makeStyles<AlyceTheme>(({ palette }) => ({
  text: {
    color: `${palette.text.primary} !important`,
  },
}));

export interface IRecipientInfoProps {
  fullName: string;
  email: string;
}

const RecipientInfo = ({ email, fullName }: IRecipientInfoProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Box mt={2} overflow="hidden">
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        height={['auto', '100%']}
      >
        <Box className={classNames('H4-Dark-Bold', classes.text)} data-testid="RecipientInfo.ShippingRecipientName">
          {fullName}
        </Box>
        <Box
          mb={0.5}
          width="100%"
          display="flex"
          justifyContent="space-between"
          flexDirection={['column', 'row']}
          data-testid="RecipientInfo.ShippingRecipientEmail"
          className="Body-Regular-Left-Static"
        >
          <Box>{email}</Box>
          <Box alignItems="flex-end" display="flex" justifyContent="flex-start" className="Body-Small-Inactive">
            Need some help?&nbsp;
            <SupportLink />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default memo<IRecipientInfoProps>(RecipientInfo);
